import React from "react";


export default function IconMaps() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.03 2.00002C14.29 2.01002 16.45 2.91002 18.03 4.49002C19.62 6.08002 20.51 8.23002 20.5 10.46V10.51C20.44 13.54 18.74 16.33 16.62 18.51C15.42 19.74 14.09 20.83 12.64 21.75C12.25 22.08 11.68 22.08 11.29 21.75C9.14 20.35 7.24 18.59 5.7 16.54C4.35 14.76 3.58 12.62 3.5 10.39C3.52 5.74002 7.34 1.99002 12.03 2.00002ZM12.03 13.26C12.74 13.26 13.42 12.99 13.92 12.5C14.44 11.99 14.731 11.311 14.731 10.6C14.731 9.12002 13.52 7.93002 12.03 7.93002C10.54 7.93002 9.34 9.12002 9.34 10.6C9.34 12.061 10.52 13.24 12 13.26H12.03Z" fill="#3582B9"/>
        </svg>
    )
}